import React, {useState} from 'react';
import { useManagers, unsetCurrent, updateManager, createManager } from '../../context/managers/ManagersState';
import { Input } from '@progress/kendo-react-inputs';


const ManagerItem = ({ manager }) => {
    const [managersState, managersDispatch] = useManagers();
    const { current } = managersState;
    const [name, setName] = useState(manager.name || "");
    const [phone, setPhone] = useState(manager.phone || "");
    const [email, setEmail] = useState(manager.email || "");
    const [emailError, setEmailError] = useState("");
    const [phoneError, setPhoneError] = useState("");

    const validateEmail = (value) => {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return !value ||regex.test(value);
    };

    const validatePhone = (value) => {
        const regex = /^\+?[\d\s\-]{10}$/;
        return regex.test(value);
    };

    const onEmailChange = (e) => {
        const val = e.target.value;
        setEmail(val);
        
        if (!val || validateEmail(val)) {
          setEmailError("");
        } else {
          setEmailError("פורמט האימייל לא תקין");
        }
    };
    
    const onPhoneChange = (e) => {
        const val = e.target.value;
        setPhone(val);
        if (!val || validatePhone(val)) {
          setPhoneError("");
        } else {
          setPhoneError("מספר הטלפון לא תקין");
        }
    };

    const onNameChange = (e) => {
        const val = e.target.value;
        setName(val);
    };

    const onSubmit = (e) => {
        e.preventDefault();
    
        // Final validation before submit
        let valid = true;
        if (!validateEmail(email)) {
          setEmailError("פורמט האימייל לא תקין");
          valid = false;
        }
        if (!phone || !validatePhone(phone)) {
          setPhoneError("מספר הטלפון לא תקין");
          valid = false;
        }
    
        if (!valid) return;
    
        // Submit form here
        if (manager.id) {
            managersDispatch(updateManager(managersDispatch, {id: manager.id, name: name, email: email, phone: phone}));
        } else {
            managersDispatch(createManager(managersDispatch, {name: name, email: email, phone: phone}));
        }
    };
    
    

    
    return (current ?
        <div className='card cardManager'>
            
            <div className='card_wrapper'>
                
                <form onSubmit={onSubmit}>
                <div className='card_wrapper_body'>
                    <div className='card_wrapper_body_item'>
                        שם מלא: <Input type="text" value={name} onChange={onNameChange} className={current.name ? 'disabled' : ''}/>
                    </div>
                    <div className='manager_item_error'></div>
                </div>
                <div className='card_wrapper_body'>
                    <div className='card_wrapper_body_item'>
                        טלפון: <Input type="tel" value={phone} onChange={onPhoneChange} />
                    </div>
                    <div className='manager_item_error'>{phoneError}</div>
                    <div className='card_wrapper_body_item'>
                        אימייל: <Input type="email" value={email} onChange={onEmailChange} />
                    </div>
                    <div className='manager_item_error'>{emailError}</div>
                </div>
                <div className='card_wrapper_footer'>
                    <button className='btn' type="submit" disabled={emailError || phoneError} >שמירה</button>
                </div>
                </form>
            </div>
        </div> : false

    )
}


export default ManagerItem
